
export const formatMinSec = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  let secs = seconds - minutes * 60;
  if (secs < 10)
    secs = `0${secs}`;
    
  return `${minutes}:${secs}`;
};
export const formatPrice = (cents) => (cents / 100).toLocaleString('es-ES');

export const formatPriceTwoDecimals = (cents) => (cents / 100).toFixed(2).toLocaleString('es-MX');

export const catchErrors = (fn) => {
  return function(...args) {
    return fn(...args).catch(err => {
      return Promise.reject('An error ocurred: ' + err);
    });
  };
};

export const reverseObj = (obj) => {
  let newObj = {}

  Object.keys(obj)
    .sort()
    .forEach((key) => newObj[key] = obj[key]);

  return newObj;
}

export const mask = (pattern, value, key) => {
  if (key === 8) { return value; }
  
  const idx = value.length === 0 ? 0 : value.length;

  if (pattern[idx] && pattern[idx] !== '*') {
    return `${value}${pattern[idx]}`;
  }

  return value;
};
export const mutateValidRut = (value, key) => key !== 8 && /^[0-9a-zA-Z]{8}$/.test(value) ? value + '-' : value;

export const validations = {
  messages: {
    notEmpty: () => 'El campo no puede ir vacío.',
    email: () => 'El campo no contiene un correo electrónico válido.',
    maxLength: (length) => `El campo no puede exceder ${length} caracteres.`,
    minLength: (length) => `El campo debe tener al menos ${length} caracteres.`,
    alpha: () => 'El campo no puede incluir caracteres especiales.',
    confirmation: () => 'Los campos no corresponde',
    rut: () => 'Tarjeta MovieYELMO inválida',
    noSpaces: () => 'El campo no puede contener espacios.',
    numeric: () => 'El campo solo puede contener números.',
    date: () => 'Por favor ingresa una fecha válida.'
  },
  notEmpty: (value) => value && value !== '',
  email: (value) => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(value),
  maxLength: (value, length) => value.length <= length,
  minLength: (value, length) => value.length >= length,
  alpha: function (value) {
    if (!this.notEmpty(value)) {
      return true;
    }
    return /^[a-zA-ZÑñáéíóúÁÉÍÓÚ´]+$/.test(value.replace(/\s+/g, ''));
  },
  confirmation: (value, valueToCompare) => value === valueToCompare,
  rut: (value) => /^[0-9]{8}-(?:[0-9]|k|K){1}$/.test(value),
  noSpaces: (value) => !/\s+/g.test(value),
  numeric: function (value) {
    if (!this.notEmpty(value)) {
      return true;
    }

    return /^[0-9]+$/.test(value.replace(/\s+/g, ''));
  },
  date: (value) => {
    const valsArr = value.split('/');
    const month = valsArr[0];
    const year = valsArr[1];
    const currentDate = new Date();
    const supplyDate = new Date(year, month, currentDate.getDay());

    return supplyDate >= currentDate;
  }
};

export const check_os = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};
